import React from 'react';
import PropTypes from 'prop-types';
import OurTeamLayout from './OurTeamLayout';
import Accordion from '../Accordion';

import {
  MainOurTeam,
  WrapperOurTeam,
  HeaderOurTeamAccordion,
  TitleOurTeam,
  SummaryOurTeam
} from './style';

const OurTeamAccordion = ({ className, title, text, dataTeams }) => (
  <MainOurTeam className={className}>
    <WrapperOurTeam>
      {(title || text) && (
        <HeaderOurTeamAccordion>
          {title && <TitleOurTeam>{title}</TitleOurTeam>}
          {text && <SummaryOurTeam>{text}</SummaryOurTeam>}
        </HeaderOurTeamAccordion>
      )}
      {dataTeams &&
        dataTeams.map((item, key) => (
          <Accordion
            title={item.title}
            level={key + 1}
            mainId={item.mainId}
            secondaryId={item.secondaryId}
          >
            <OurTeamLayout dataTeam={item.team} />
          </Accordion>
        ))}
    </WrapperOurTeam>
  </MainOurTeam>
);

OurTeamAccordion.propTypes = {
  className: PropTypes.string,
  title: PropTypes.string,
  text: PropTypes.string,
  dataTeams: PropTypes.shape({
    title: PropTypes.string,
    mainId: PropTypes.string,
    secondaryId: PropTypes.string,
    team: PropTypes.shape({
      person: PropTypes.string,
      job: PropTypes.string
    })
  })
};

export default OurTeamAccordion;
